var base = require('navbar/navbar');

Vue.component('spark-navbar', {
    mixins: [base],

    methods: {
        removeSearch() {
            localStorage.setItem('last_search', '');
            localStorage.setItem('last_name_search', '');
        }
    }
});
